import { Component, OnInit } from '@angular/core';
import { isDevMode } from '@angular/core';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  isDev: boolean;

  constructor() {
  }

  ngOnInit() {
    this.isDev = isDevMode();
  }

}
